import { use } from 'react';
import {
  UPDATE_PREVIEW_DATA,
  RESET_PREVIEW_DATA,
  UPDATE_PREVIEW_MEDIA,
  UPDATE_PREVIEW_CONTENT,
  SET_PREVIEW_PLATFORM,



  SET_ENGAGEMENT_DATA,
  UPDATE_REACTIONS,
  ADD_COMMENT,
  DELETE_COMMENT,
  UPDATE_ANALYTICS,
  UPDATE_COMMENT_LIKES,
  SET_PLATFORM_DATA,
  TOGGLE_REACTION,
  UPDATE_IMPRESSIONS,
  ADD_SHARE,
  SET_POST_VISIBILITY,
  UPDATE_POST_STATS,


} from '../constants/action-types/preview';
import { comment } from 'learning/redux/actions/actions';
import { vi } from 'date-fns/locale';

// Updated preview reducer initial state
export const initialState = {
  platform: 'linkedin',
  selectedPlatform: 'linkedin',
  author: {
    name: '',
    image: '/api/placeholder/48/48',
    description: '',
    isYou: true
  },
  content: {
    mainText: [],
    hashtags: [],
    media: []
  },
  engagement: {
    likes: 0,
    comments: [],
    shares: 0,
    views: 0
  },
  analytics: {
    impressions: 0,
    engagementRate: 0,
    breakdown: {
      likes: 0,
      comments: 0,
      shares: 0
    }
   
  },
  timestamp: 'Just now',
  username: '',
  isVerified: false,

  platforms: {
    linkedin: {
      posts: [],
      analytics: {
        impressions: 0,
        engagementRate: 0,
        breakdown: {
          likes: 0,
          comments: 0,
          shares: 0
        }
      }
    },
    facebook: {
      posts: [],
      analytics: {
        impressions: 0,
        engagementRate: 0,
        breakdown: {
          likes: 0,
          comments: 0,
          shares: 0
        }
      }
    },
    twitter: {
      posts: [],
      analytics: {
        impressions: 0,
        engagementRate: 0,
        breakdown: {
          likes: 0,
          comments: 0,
          shares: 0
        }
      }
    }
  },
  engagementData: {
    reactions: [],
    comments: [],
    shares: []
  },
  postVisibility: 'public'
};


const calculateEngagementRate = (analytics) => {
  const totalEngagements = 
    analytics.breakdown.likes + 
    analytics.breakdown.comments + 
    analytics.breakdown.shares;
  
  return analytics.impressions > 0 
    ? ((totalEngagements / analytics.impressions) * 100).toFixed(2)
    : 0;
};

const updatePlatformStats = (state, platform, updatedStats) => {
  return {
    ...state,
    platforms: {
      ...state.platforms,
      [platform]: {
        ...state.platforms[platform],
        analytics: {
          ...state.platforms[platform].analytics,
          ...updatedStats,
          engagementRate: calculateEngagementRate({
            ...state.platforms[platform].analytics,
            ...updatedStats
          })
        }
      }
    }
  };
};


export default function previewReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PREVIEW_PLATFORM:
      return {
        ...state,
        selectedPlatform: action.payload
      };
    case UPDATE_PREVIEW_DATA:
      return {
        ...state,
        ...action.payload
      };
    
    case RESET_PREVIEW_DATA:
      return initialState;
    
    case UPDATE_PREVIEW_MEDIA:
      return {
        ...state,
        content: {
          ...state.content,
          media: Array.isArray(action.payload) ? action.payload : [action.payload]
        }
      };
    
    case UPDATE_PREVIEW_CONTENT:
      return {
        ...state,
        content: {
          ...state.content,
          ...action.payload
        }
      };
    

      case SET_PLATFORM_DATA:
        return {
          ...state,
          currentPlatform: action.payload.platform,
          platforms: {
            ...state.platforms,
            [action.payload.platform]: {
              ...state.platforms[action.payload.platform],
              posts: action.payload.posts
            }
          }
        };
  
      case SET_ENGAGEMENT_DATA:
        return {
          ...state,
          engagementData: {
            ...state.engagementData,
            ...action.payload
          }
        };
  
      case UPDATE_REACTIONS:
        const { postId: reactionPostId, reaction, userId } = action.payload;
        const updatedReactions = state.engagementData.reactions.map(r => 
          r.postId === postId 
            ? {
                ...r,
                users: r.users.find(u => u.id === userId)
                  ? r.users.filter(u => u.id !== userId)
                  : [...r.users, { id: userId, type: reaction }]
              }
            : r
        );
  
        return {
          ...state,
          engagementData: {
            ...state.engagementData,
            reactions: updatedReactions
          }
        };
  
      case ADD_COMMENT:
        return {
          ...state,
          engagementData: {
            ...state.engagementData,
            comments: [...state.engagementData.comments, action.payload]
          }
        };
  
      case DELETE_COMMENT:
        return {
          ...state,
          engagementData: {
            ...state.engagementData,
            comments: state.engagementData.comments.filter(
              comment => comment.id !== action.payload
            )
          }
        };
  
      case UPDATE_COMMENT_LIKES:
        const { commentId, userId: likeUserId } = action.payload;
        const updatedComments = state.engagementData.comments.map(comment =>
          comment.id === commentId
            ? {
                ...comment,
                likes: comment.likes.includes(likeUserId)
                  ? comment.likes.filter(id => id !== likeUserId)
                  : [...comment.likes, likeUserId]
              }
            : comment
        );
  
        return {
          ...state,
          engagementData: {
            ...state.engagementData,
            comments: updatedComments
          }
        };
  
      case UPDATE_ANALYTICS:
        return updatePlatformStats(
          state,
          action.payload.platform,
          action.payload.analytics
        );
  
      case UPDATE_IMPRESSIONS:
        return updatePlatformStats(
          state,
          action.payload.platform,
          {
            impressions: action.payload.impressions
          }
        );
  
      case ADD_SHARE:
        return {
          ...state,
          engagementData: {
            ...state.engagementData,
            shares: [...state.engagementData.shares, action.payload]
          }
        };
  
      case SET_POST_VISIBILITY:
        return {
          ...state,
          postVisibility: action.payload
        };
  
      case UPDATE_POST_STATS:
        const { platform, postId, stats } = action.payload;
        return {
          ...state,
          platforms: {
            ...state.platforms,
            [platform]: {
              ...state.platforms[platform],
              posts: state.platforms[platform].posts.map(post =>
                post.id === postId
                  ? { ...post, stats: { ...post.stats, ...stats } }
                  : post
              )
            }
          }
        };
    default:
      return state;
  }
}